export * from './Rules';

import * as Rules from './Rules'
export default Rules